export enum EJourneys {
    FINANCE = 'FINANCE',
    TEST_DRIVE = 'TEST_DRIVE',
}
